import { toast } from "svelte-sonner";

export async function copyToClipboard(text: string, toastMessage?: string) {
	if (navigator.clipboard && window.isSecureContext) {
		await navigator.clipboard.writeText(text);
	} else {
		//Copy localhost

		// Use the 'out of viewport hidden text area' trick
		const textArea = document.createElement("textarea");
		textArea.value = text;

		// Move textarea out of the viewport so it's not visible
		textArea.style.position = "fixed";
		textArea.style.left = "-999999px";

		document.body.prepend(textArea);
		textArea.select();

		try {
			// Deprecated API but we need it for fallback
			// Typecase to prevent deprecated warming
			(document as any).execCommand("copy");
		} catch (error) {
			console.error(error);
		} finally {
			textArea.remove();
		}
	}

	if (toastMessage) {
		toast.info(toastMessage);
	}
}
